module.exports = __webpack_public_path__ + "img/ag-white-logo.6fc17ddc.svg";